import React from 'react';

// Botão-pílula da home aprovada — 3 variantes (gradient stela sancionado)
type PillVariant = 'primary' | 'gold' | 'ghost';

interface PillButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: PillVariant;
  full?: boolean;
}

const VARIANTS: Record<PillVariant, string> = {
  primary: 'bg-gradient-to-br from-stela-accent to-stela-accent2 text-white font-semibold hover:brightness-110',
  gold: 'bg-gradient-to-br from-[#F3D488] to-[#D9A640] text-[#241A05] font-semibold hover:brightness-110',
  ghost: 'border border-stela-line text-stela-lilac hover:bg-white/5',
};

export const PillButton: React.FC<PillButtonProps> = ({
  variant = 'primary',
  full,
  className = '',
  children,
  ...props
}) => {
  return (
    <button
      className={`inline-flex items-center justify-center gap-2 min-h-[44px] text-body font-semibold px-6 py-2.5 rounded-full transition disabled:opacity-60 ${VARIANTS[variant]} ${full ? 'w-full' : ''} ${className}`}
      {...props}
    >
      {children}
    </button>
  );
};